import * as React from 'react';
import { ComplexValue } from '../common/types';
import { Icon } from 'ui/common/icon';
import styles from './icon-list.scss';
import { Tooltip } from 'ui/common/tooltip/tooltip';

export interface IconListProps {
  valueItems: ComplexValue<number>[];
  title?: string;
  defaultIcon?: JSX.Element;
}

const icon = (valueItem: any, defaultIcon) =>  {
  return (<div className={`${valueItem.propName || ''} icon-list-item`} key={valueItem.value}>
            {valueItem.icon ? <Icon url={valueItem.icon}/> : defaultIcon}
          </div>);
};

const icons = (valueItems: any, defaultIcon) => {
  return valueItems.map((valueItem) => icon(valueItem, defaultIcon));
};

export const IconList = ({title, valueItems, defaultIcon}:IconListProps ) => (
  <Tooltip
    className={styles.tooltipOverwrite}
    title={valueItems?.map(item => item.description).join('\n')}
    delayed={true}
    center={true}
    narrow={true}>
    <div className={`${styles.iconlistWrapper} icon-list-wrapper`}>
      <label className={styles.label}>{title}</label>
      <div className="icon-list" data-children={valueItems?.length}>
        {!!valueItems && icons(valueItems, defaultIcon)}
      </div>
    </div>
  </Tooltip>
);
